/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Records_Region_LabelInputs */

const en_automatic_save_records_region_label = /** @type {(inputs: Automatic_Save_Records_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Save Records`)
};

const fr_automatic_save_records_region_label = /** @type {(inputs: Automatic_Save_Records_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrements de sauvegarde automatique`)
};

const de_automatic_save_records_region_label = /** @type {(inputs: Automatic_Save_Records_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Speicherung von Datensätzen`)
};

const it_automatic_save_records_region_label = /** @type {(inputs: Automatic_Save_Records_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio automatico dei record`)
};

const ru_automatic_save_records_region_label = /** @type {(inputs: Automatic_Save_Records_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое сохранение записей`)
};

const es_automatic_save_records_region_label = /** @type {(inputs: Automatic_Save_Records_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar registros automáticamente`)
};

const zh_cn2_automatic_save_records_region_label = /** @type {(inputs: Automatic_Save_Records_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动保存记录`)
};

const ja_automatic_save_records_region_label = /** @type {(inputs: Automatic_Save_Records_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レコードの自動保存`)
};

const hi_automatic_save_records_region_label = /** @type {(inputs: Automatic_Save_Records_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्ड स्वतः सहेजें`)
};

const pt_pt2_automatic_save_records_region_label = /** @type {(inputs: Automatic_Save_Records_Region_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros de salvamento automático`)
};

/**
* | output |
* | --- |
* | "Auto Save Records" |
*
* @param {Automatic_Save_Records_Region_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_records_region_label = /** @type {((inputs?: Automatic_Save_Records_Region_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Records_Region_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_records_region_label(inputs)
	if (locale === "de") return de_automatic_save_records_region_label(inputs)
	if (locale === "it") return it_automatic_save_records_region_label(inputs)
	if (locale === "ru") return ru_automatic_save_records_region_label(inputs)
	if (locale === "es") return es_automatic_save_records_region_label(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_records_region_label(inputs)
	if (locale === "ja") return ja_automatic_save_records_region_label(inputs)
	if (locale === "hi") return hi_automatic_save_records_region_label(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_records_region_label(inputs)
	return en_automatic_save_records_region_label(inputs)
});